<ng-container *transloco="let t">
    <bazis-button
        size="mini"
        fill="clear"
        [disabled]="!(buttonStatus$ | async)?.prevEnabled"
        (click)="changeDate(-1)"
    >
        <bazis-icon
            slot="icon-only"
            [name]="icons.left"
        ></bazis-icon>
    </bazis-button>
    <div #inputDate>
        <bazis-button
            size="mini"
            fill="clear"
            #generalBtn
            (click)="openCalendar($event)"
        >
            <bazis-icon
                slot="start"
                size="compact"
                [name]="icons.date"
            ></bazis-icon>
            <ng-container *ngIf="!dateValue.value"> {{ t('title.hasNot') }} </ng-container>
            <ng-container *ngIf="dateValue.value === today"> {{ t('title.today') }}</ng-container>
            <ng-container *ngIf="dateValue.value === yesterday">
                {{ t('title.yesterday') }}
            </ng-container>
            <ng-container *ngIf="dateValue.value === tomorrow">
                {{ t('title.tomorrow') }}
            </ng-container>
            <ng-container
                *ngIf="
                    dateValue.value !== tomorrow &&
                    dateValue.value !== yesterday &&
                    dateValue.value !== today
                "
            >
                {{ dateValue.value }}
            </ng-container>
        </bazis-button>
    </div>
    <bazis-button
        size="mini"
        fill="clear"
        [disabled]="!(buttonStatus$ | async)?.nextEnabled"
        (click)="changeDate(1)"
    >
        <bazis-icon
            slot="icon-only"
            [name]="icons.right"
        ></bazis-icon>
    </bazis-button>
    <div
        class="bh-popper-z-index"
        #calendar
        [hidden]="!showCalendar"
        clickOutside
        [excludeElement]="generalBtn"
        (clickOutside)="clickPopperOutside()"
        (click)="clickPopper()"
    >
        <bazis-datepicker
            *ngIf="showCalendar"
            [value]="calendarValue"
            (valueChange)="setValueFromCalendar($event)"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [startYear]="startYear"
            [formatOutput]="displayFormat"
            [marks$]="marks$"
            [viewConfig]="datapickerViewConfig"
        ></bazis-datepicker>
    </div>
</ng-container>
